<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-main>
                    <toolBar :loading.sync="mainLoading"
                             :menuId="menu_id"
                             :searchData="searchData"
                             @search="search"
                             @excel="excel">
                    </toolBar>

                <el-table
                        ref="table"
                        :data="dataList"
                        height="400"
                        style="width: 100%;"
                        highlight-current-row
                        :header-cell-style="headerStyle"
                        :cell-style="cellStyle"
                        row-key="id"
                        border>
                    <el-table-column
                            type="index"
                            :index="(pageInfo.page-1) * pageInfo.pagesize+1"
                            label="序号"
                            align="center"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            prop="itemOne"
                            label="资产"
                            align="left"
                            width="200">
                    </el-table-column>
                    <el-table-column
                            prop="rowNoOne"
                            label="行次"
                            align="center"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="totalStartOne"
                            label="年初数"
                            align="right"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="totalEndOne"
                            label="期末数"
                            align="right"
                            width="150">
                    </el-table-column>

                    <el-table-column
                            prop="itemTwo"
                            label="负债和所有者权益(或股东权益)"
                            align="left"
                            width="200">
                    </el-table-column>
                    <el-table-column
                            prop="rowNoTwo"
                            label="行次"
                            align="center"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="totalStartTwo"
                            label="年初数"
                            align="right"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="totalEndTwo"
                            label="期末数"
                            align="right"
                            width="150">
                    </el-table-column>
                </el-table>
                <div class="pagStyle">
                    <pagination :pageInfo="pageInfo" @toPage="toPage"></pagination>
                </div>
            </el-main>
        </el-container>

        <outportExcel v-if="showOutportDialog"
                      :outportKey="outportKey"
                      :dataList="dataList"
                      :excelName="excelName"
                      @closeDialog="closeDialog">
        </outportExcel>
    </div>
</template>

<script>
    import toolBar from '@/components/page/finance/liabilities/toolBar'
    import outportExcel from "@/components/tools/excel/outport";
    import pagination from "@/components/tools/table/pagination";
    import {MessageBox} from "element-ui";


    export default {
        name: "liabilities",
        props: ['menuData'],
        components: {outportExcel, toolBar,pagination},
        data() {
            return {
                mainLoading: false,
                menu_id: this.menuData.menuId,
                searchData: {
                    formData:{}
                },

                showOutportDialog:false,
                outportKey: [
                    {
                        key: 'itemOne', name: '资产', checked: true, import: true
                    }, {
                        key: 'rowNoOne', name: '行次', checked: true, import: true
                    }, {
                        key: 'totalStartOne', name: '年初数', checked: true, import: true
                    }, {
                        key: 'totalEndOne', name: '期末数', checked: true, import: true
                    },
                    {
                        key: 'itemTwo', name: '负债和所有者权益(或股东权益)', checked: true, import: true
                    }, {
                        key: 'rowNoTwo', name: '行次', checked: true, import: true
                    }, {
                        key: 'totalStartTwo', name: '年初数', checked: true, import: true
                    }, {
                        key: 'totalEndTwo', name: '期末数', checked: true, import: true
                    }],
                excelName:"资产负债表",
                width: "350px",
                dialogLoading: false,
                formData: {},
                tableH: 100,
                dataList: [],
                loading: false,
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                }
            }
        },
        methods: {
            async getListData() {
                if(this.searchData.formData.yearMonth==null || this.searchData.formData.yearMonth==''){
                    this.$message({message: '请选择统计年月', type: 'error'});
                    return false;
                }

                //查询是否已存在
                let param = {
                    url: "/liabilities/getLiabilities",
                    param: {
                        ...this.searchData.formData
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param);
                if (data.infoCode == "0") {
                    let count=data.data;
                    if(parseFloat(count)>0){
                        MessageBox.confirm('已存在('+this.searchData.formData.yearMonth+')的资产负债表, 是否重新生成?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(async () => {
                            this.getLiabilities(1);
                        }).catch(() => {
                            this.getLiabilities(0);
                        })
                    }else{
                        this.getLiabilities(1);
                    }
                }
            },
            async getLiabilities(reCreate) {
                this.loading = true;
                this.searchData.formData.reCreate=reCreate;
                let param = {
                    url: "/liabilities/listLiabilities",
                    param: {
                        ...this.searchData.formData,
                        limit: this.pageInfo.pagesize,
                        page: this.pageInfo.page
                    }
                }
                const data_new = await this.$store.dispatch('pubMethod', param)
                if (data_new.infoCode == "0") {
                    this.dataList = data_new.data.data;
                    this.pageInfo.total = data_new.data.count;
                }
                this.loading = false;
            },
            toPage() {
                this.getListData();
            },
            closeDialog() {
                this.showOutportDialog = false;
            },
            search(data) {
                this.searchData.formData = data;
                this.pageInfo.page = 1;
                this.getListData();
            },
            excel() {
                this.showOutportDialog = true;
            },
            headerStyle() {
                return "text-align:center;height:35px;line-height:35px;padding: 5px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
            tableOpt() {
            },
        }
    }
</script>

<style scoped lang="scss">

    ::v-deep .el-tabs__header{
        margin:0px;
    }
    ::v-deep .el-tabs--border-card>.el-tabs__content{
        padding: 10px;
    }

   .mainInfo {
        .el-header {
            padding: 0px;
        }

        .el-main {
            padding: 0px;
        }

        .Xdriver {
            position: relative;
            margin: 0 0;
            height: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }

        .Ydriver {
            position: relative;
            margin: 0 10px;
            width: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }
    }
</style>
